import { useAuthStore } from '@/stores/authStore'

/**
 * Returns the Convex organization `_id` for the currently selected org.
 *
 * The auth store's `currentOrganization.organizationId` holds the Convex ID
 * (synced by AuthSyncProvider from `getMyOrganizations`). Use this when
 * calling Convex mutations/queries that require an `Id<"organizations">`.
 *
 * For old Hono API routes (which expect the internal UUID), use
 * `useCurrentOrganizationId()` instead.
 */
export function useMyConvexOrganizationId(): string | undefined {
  return useAuthStore((s) => s.currentOrganization?.organizationId) ?? undefined
}
